
import icon from "../assets/buttonarrow.png";
import React, { useEffect } from 'react';

const AnimatedArrowButton = ({ text, link , width='150px' }) => {
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      .fancy-arrow-button {
        --offset: 2px;
        background: #3B341E;
        border-radius: 50px;
        position: relative;
        height: 45px;
        width: ${width};
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .fancy-arrow-button::before {
        content: '';
        background: conic-gradient(transparent 270deg, #FFD52B, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        aspect-ratio: 1;
        width: 100%;
        animation: rotate 2s linear infinite;
      }

      .fancy-arrow-button::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
      }

      .button {
        background: transparent;
        color: #FFD52B;
        font-size: 1rem;
        font-weight: 500;
        z-index: 10;
        text-decoration: none;
        display:flex;
        
      }

      @keyframes rotate {
        from {
          transform: translate(-50%, -50%) scale(1.4) rotate(0turn);
        }
        to {
          transform: translate(-50%, -50%) scale(1.4) rotate(1turn);
        }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <div className="fancy-arrow-button">
      <a href={link} className="button" style={{alignItems:'center'}}>
        <div>{text}</div>
        <img src={icon} height='15px' width='15px' style={{marginLeft:'8px'}}></img>
      </a>
    </div>
  );
};




export default AnimatedArrowButton;
